module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/hero_image@1x.cf87a89.png";